import { Fragment } from "react";
import {
  ALTCHA_STATUS_MESSAGES,
  type AltchaState,
} from "@/features/post/components/altchaWidgetBehavior";
import { Button } from "@/shared/ui/form";

type Props = {
  attachWidget: (element: HTMLElement | null) => (() => void) | undefined;
  descriptionId: string;
  labelId: string;
  onRetry: () => void;
  state: AltchaState;
  widgetGeneration: number;
};

export function AltchaWidgetView({
  attachWidget,
  descriptionId,
  labelId,
  onRetry,
  state,
  widgetGeneration,
}: Props): React.ReactElement {
  const isFailure = state === "error" || state === "expired";
  const statusMessage = ALTCHA_STATUS_MESSAGES[state];

  return (
    <section
      className={isFailure ? "space-y-2" : undefined}
      aria-labelledby={labelId}
    >
      <span id={labelId} className="sr-only">
        書き込み認証
      </span>
      <Fragment key={widgetGeneration}>
        <altcha-widget
          ref={attachWidget}
          className="altcha-widget-element"
          display="standard"
          type="checkbox"
          language="ja"
          name="altcha"
          aria-describedby={descriptionId}
        />
      </Fragment>
      {/*
        aria-describedby の参照先を保つため要素は残しつつ、
        表示すべき文言が無い間は hidden で縦スペースを詰める。
      */}
      <output
        id={descriptionId}
        aria-live="polite"
        aria-atomic="true"
        className="block text-xs"
        hidden={isFailure || statusMessage === ""}
      >
        {isFailure ? "" : statusMessage}
      </output>
      {isFailure && (
        <section className="space-y-2" aria-label="認証の再試行">
          <p
            role="alert"
            aria-live="assertive"
            className="text-xs text-destructive"
          >
            {statusMessage}
          </p>
          <Button
            type="button"
            variant="secondary"
            onClick={onRetry}
            className="w-full"
          >
            認証を再試行
          </Button>
        </section>
      )}
    </section>
  );
}
